import React, { Component } from 'react';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import Dropdown from './../../../../../../Dropdown/Dropdown';
import Utils from './../../../../../../../utils';
import ScoreRange from '../../../../../constants/ScoreRange';
import ScoreBarTypes from '../../../../../constants/ScoreBarTypes';
import AppendixScoreBarSection from '../../../../../components/AppendixScoreBarSection/AppendixScoreBarSection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FoldOut from '../../../../../../FoldOut/components/FoldOut/FoldOut';
import ReportHelper from './../../../../../helpers/ReportHelper';
import Developability from './../../../../../components/Developability';
import ScoreBarNG from './../../../../../components/ScoreBarNG/ScoreBarNG';
import style from './style/competencyprofile.scss';

export default class CompetencyProfileAttachment extends Component {
    constructor(props) {
        super(props);

        this.changeSorting = this.changeSorting.bind(this);
        this.parseCompetencies = this.parseCompetencies.bind(this);

        this.state = {
            sortByScore: false,
            sortedCompetencies: Utils.alphabeticallySortFieldInArray(this.parseCompetencies(), 'name')
        };
    }

    componentDidMount() {
        this.setState({ competencies: Utils.alphabeticallySortFieldInArray(this.parseCompetencies(), 'name') });
    }

    componentDidUpdate(prevProps) {
        if (!Utils.isEqual(prevProps.i18nParticipation, this.props.i18nParticipation)) {
            this.setState({ sortedCompetencies: [
                    ...Utils.alphabeticallySortFieldInArray(this.parseCompetencies(), 'name')
                ] });
        }
    }

    parseCompetencies() {
        const { i18nParticipation, content, participant } = this.props;
        const competencies = [];
        const participantLanguage = participant.language.replace('-', '_');

        content.competencies.forEach(competency => {
            competencies.push(
                {
                    name: ReportHelper.getCompetencyName(competency, participantLanguage, i18nParticipation),
                    definition: ReportHelper.getCompetencyDefinition(competency, participantLanguage, i18nParticipation),
                    score: competency.score,
                    label: competency.label,
                    informationForRecruiterAndParticipant: {
                        commentsForParticipant: competency.commentsForParticipant,
                        tips: competency.tips,
                        commentsForOthers: competency.commentsForOthers,
                        interviewQuestions: competency.interviewQuestions
                    },
                    developabilityLabel: competency.developabilityLabel || '',
                    developabilityScore: competency.developabilityScore || '',
                    developabilityDefinition: competency.developabilityDefinition || ''
                }
            );
        });
        return competencies;
    }

    changeSorting() {
        if (this.state.sortByScore) {
            this.setState({
                sortByScore: false,
                sortedCompetencies: Utils.alphabeticallySortFieldInArray(this.state.sortedCompetencies, 'name')
            });
        } else {
            this.setState({
                sortByScore: true,
                sortedCompetencies: Utils.numericallySortFieldInArray(this.state.sortedCompetencies, 'score').reverse()
            });
        }
    }

    foldableInformationSection(competency) {
        const { classes } = this.props;
        const informationsArray = [];

        for (const [, informationObject] of Object.entries(competency.informationForRecruiterAndParticipant)) {
            if (informationObject && informationObject.text) {
                informationsArray.push(informationObject);
            }
        }

        return <section className={ style.remarks_and_interview_questions_wrapper }>
            { informationsArray.map(dropdownInformation => (
                <section
                    key={`key_${dropdownInformation.name}`}
                    className={ style.information_dropdown_wrapper }>
                    <FoldOut
                        label={ dropdownInformation.name }
                        icons={{
                            open: <FontAwesomeIcon icon={'chevron-up'}/>,
                            closed: <FontAwesomeIcon icon={'chevron-down'}/>
                        }}
                        classes={{
                            foldOut: classes.foldOut ? classes.foldOut : ''
                        }}
                    >
                        { dropdownInformation.text ? <section
                            className={ style.dropdown_content }
                            dangerouslySetInnerHTML={{ __html: dropdownInformation.text }}/> : null }
                    </FoldOut>
                </section>
            )) }
        </section>;
    }

    getDevelopabilityHeader(competency) {
        if (!competency || !competency.developabilityDefinition) {
            return null;
        }

        return <React.Fragment>
            <h3 className={ style.developabilityHeaderTitle }>{ this.props.i18nParticipation[`competencies_${competency.translationKeyName}`] || competency.name }</h3>
            <section className={ style.developabilityHeaderDefinition }>
                <figure>
                    <Developability
                        developabilityLabel={ competency.developabilityLabel }
                        developabilityScore={ competency.developabilityScore }
                        classes={{
                            root: style.developabilityIcon
                        }}
                    />
                </figure>
                <p><strong>{ competency.developabilityLabel }: </strong>{ competency.developabilityDefinition }</p>
            </section>
        </React.Fragment>;
    }

    render() {
        const { i18n, i18nParticipation, content, product } = this.props;
        const competencies = [];

        this.state.sortedCompetencies.forEach((competency, index) => {
            if (ReportHelper.shouldUseStarRanking(product.translationKey)) {
                competencies.push(
                    <ul className={ style.competencyProfileCompetency } key={ `competency_${index}` }>
                        <li>
                            <ScoreBarNG
                                scoreValue={ competency.score }
                                label={ i18nParticipation[`competencies_${competency.translationKeyName}`] || competency.name }
                                classes={{
                                    root: style.competencyProfileStarRanking,
                                    header: style.competencyProfileStarRankingHeader,
                                    active: style.starRanking__active,
                                    inactive: style.starRanking__inactive
                                }}
                                scoreBarType={ ScoreBarTypes.STARS }
                                scoreMax={ 5 }
                            />
                            <p className={ style.score_level_description }>{ competency.label }</p>
                        </li>
                        <li className={ style.competencyProfileDefinition }>{ competency.definition }</li>
                    </ul>
                );
            } else {
                competencies.push(
                    <React.Fragment key={ `competency_${index}` }>
                        { this.getDevelopabilityHeader(competency) }
                        <ul className={ style.competencyProfileCompetency }>
                            <li>
                                <AppendixScoreBarSection
                                    key={ `scale-${competency.name}` }
                                    lowLabel={ competency.label }
                                    scoreName={ i18nParticipation[`competencies_${competency.translationKeyName}`] || competency.name }
                                    scoreValue={ competency.score }
                                    scoreMin={ ScoreRange.APPENDIXES.MIN }
                                    scoreMax={ ScoreRange.APPENDIXES.MAX }
                                    scoreBarType={ ScoreBarTypes.CROISSANT }
                                    classes={ {
                                        fill: style.appendixScoreBarSection__fill,
                                        blank: style.appendixScoreBarSection__blank,
                                        scoreBlock: style.appendixScoreBarSection__scoreBlockCompetencies
                                    } }
                                    developabilityLabel={ competency.developabilityLabel }
                                    developabilityScore={ competency.developabilityScore }
                                    developabilityDefinition={ competency.developabilityDefinition }
                                />
                            </li>
                            <li className={ style.competencyProfileDefinition }>
                                { competency.definition }
                                { this.foldableInformationSection(competency) }
                            </li>
                        </ul>
                    </React.Fragment>
                );
            }
        });

        return <div className={ style.competencyProfile }>

            { content.definition
                ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                    <p dangerouslySetInnerHTML={{ __html: content.definition }}/>
                </SectionBlock>
                : null
            }

            <SectionBlock>
                <ul className={ style.competencyProfile__titleSectionContainer }>
                    <li className={ style.competencyProfileTitleSectionContainer__side }/>
                    <li>
                        <Dropdown
                            title={ i18n.report_competency_profile_attachment_sorting_header }
                            onChange={ this.changeSorting }
                            value={ this.state.sortByScore ? 1 : 0 }
                            classes={{
                                root: style.competencyProfile__dropdown,
                                optionSelection: style.competencyProfile__optionSelection
                            }}
                        >
                            <option value="0">{ i18n.report_competency_profile_attachment_sorting_alphabet }</option>
                            <option value="1">{ i18n.report_competency_profile_attachment_sorting_score }</option>
                        </Dropdown>
                    </li>
                    <li className={ style.competencyProfileTitleSectionContainer__side }/>
                </ul>
                { competencies }
            </SectionBlock>
        </div>;
    }
}
